import { render, staticRenderFns } from "./expressview.vue?vue&type=template&id=22ff1707&scoped=true&"
import script from "./expressview.vue?vue&type=script&lang=js&"
export * from "./expressview.vue?vue&type=script&lang=js&"
import style0 from "./expressview.vue?vue&type=style&index=0&id=22ff1707&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff1707",
  null
  
)

export default component.exports